import { InputArea } from "@wix/design-system";
import React from "react";
import { EDIT_PANEL_HTML_INPUT } from "../../data-hooks.js";
const HtmlInputArea = ({ placeholder, value, onChange }) => {
  return /* @__PURE__ */ React.createElement(
    InputArea,
    {
      size: "small",
      placeholder,
      dataHook: EDIT_PANEL_HTML_INPUT,
      value,
      onChange: (e) => onChange(e.target.value),
      minHeight: "244px"
    }
  );
};
export {
  HtmlInputArea
};
//# sourceMappingURL=HtmlInputArea.js.map
